import api from "src/spintr/SpintrApi";
import { IAttentionCount, IAttentionList } from "./types";

const baseUrl = "/api/v1/attention";

export async function fetchAttentionList(signal?: AbortSignal): Promise<IAttentionList> {
    const response = await api.get<IAttentionList>(baseUrl, { signal });

    return response.data;
}

export async function fetchAttentionCount(signal?: AbortSignal): Promise<IAttentionCount> {
    const response = await api.get<IAttentionCount>(`${baseUrl}/count`, { signal });

    return response.data;
}

export async function dismissAttentionIntro(): Promise<void> {
    await api.post(`${baseUrl}/intro/dismiss`);
}
